import React, { useState, useEffect } from 'react'

import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Table,
  Alert,
  FormGroup,
} from 'reactstrap'
import { connect } from 'react-redux'
import { Async } from 'react-select'
import moment from 'moment'
import axios from '../../../../axios'
import * as url from '../../../../utils/url'
import { snapToQuarterHour } from '../../../../utils/dateUtils'
import * as actionCreators from '../../../../modules/actions/index'
import Loading from '../../../../hoc/Loading/Loading'
import { AiFillCloseCircle } from 'react-icons/ai'
import { MdFileUpload, MdOutlineMobileFriendly } from 'react-icons/md'
import { FaArrowRight } from 'react-icons/fa6'
import Select from 'react-select'
import { SURVEY_QUESTIONS } from '../../../../components/Survey/data'
import {
  BiCaretDown,
  BiCaretUp,
  BiMailSend,
  BiTrashAlt,
  BiX,
} from 'react-icons/bi'
import { BsThreeDots } from 'react-icons/bs'
import {
  generateRandomString,
  isUrlValid,
  profilePicValidityCheck,
  trivvyFileTypeCheck,
  uploadPreview,
} from '../../../../utils/constants'
import { toastContainer } from '../../../../utils/toast'
import {
  getFileTypeFromUrl,
  getTriviaFileName,
  NUMBER_OF_ATTEMPTS_ALLOWED,
  WEB_GENERATE_ERROR_MESSAGE,
  TRIVIA_SHARE_PRIVACY_OPTIONS,
  TRIVIA_USER_IDENTIFICATION_OPTIONS,
  TRIVVY_LANGUAGES,
  minPlanLimitCheck,
  DIFFICULTY_LEVELS,
  BUILT_WITH_AI_PROMPTS,
  BUILT_WITH_AI_PROMPTS_STANDARD,
} from '../../data'
import ReactDatePicker from 'react-datepicker'
import Toggle from 'react-toggle'
import CheckBox from 'rc-checkbox'
import ReactTooltip from 'react-tooltip'
import {
  ActionLayoutData,
  ActionLayoutHeading,
  LayoutData,
  LayoutHeading,
  LayoutRow,
} from '../../../../pages/weekly-wins/TableLayoutComponents'
import { SELECT_NO_OF_TRIVVYS } from '../../LibraryModule/data'
import { isMobile } from '../../../../utils/deviceInfo'
import Steps from '../../../../components/Steps/Steps'
import SupportedLanguagesText from '../../../../components/Trivvy/SupportedLanguagesText'
import SourceSelector from '../../../../components/Trivvy/SourceSelector'
import OoPopover from '../../../../components/UI/Popover/OoPopover'
import BuildAithAiCard from './BuildWithAicard'
import QuestionPreviewStep from './QuestionPreviewStep'
import UpgradeTag from '../../../../components/UpgradeTag'

const questionOptions = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
]

const uploadOptions = [
  { label: 'Library', value: 0 },
  { label: 'Upload File', value: 1 },
  { label: 'Custom Text', value: 2 },
  { label: 'Webpage', value: 3 },
]

const triviaTypeOptions = [
  { label: 'AI generated', value: 1 },
  { label: 'Custom', value: 2 },
]

function CreateTriviaPopup({
  open,
  onClose,
  onAddSuccess,
  generateFromLibrary,
  preSelectedData,
  resourceId,
  incrementTrivCount,
  generateNewLibDocfromTools,
  user,
  onBack,
  uiType = 'POPUP',
  autoSelectedTrivvyType = 'AI',
  onTrivvyMultiGenerate,
  setCreateTrivvyLoader,
  onlyAllowCustomTextPrompt,
  setImportTemplateAddedTrivvys,
  preSelectedLibraryItem,
  ...props
}) {
  const [formData, setFormData] = useState({
    name: '',
    fileUrl: '',
    uploadType: null,
    uploadText: '',
    triviaType: '',
    libraryId: null,
    questionsCount: null,
    trivvyParts: onlyAllowCustomTextPrompt
      ? [
        {
          name: '',
          scheduledDate: null,
          privacy: 'PUBLIC',
          sharedWithUsers: [],
        },
      ]
      : [],
    noOfTrivvys: onlyAllowCustomTextPrompt ? 1 : 0,
  })

  const [errorsArr, setErrorsArr] = useState([])

  const planInvalidSms =
    user.profile && user.profile.organizationId
      ? ['001'].includes(user.profile.organizationId.trivvyPlanType)
      : false

  const currentPaymentPlan =
    user.profile &&
    user.profile.organizationId &&
    user.profile.organizationId.trivvyPlanType

  const showLanguageFeature = minPlanLimitCheck(currentPaymentPlan, '003')

  const isEnterprisePlan = minPlanLimitCheck(currentPaymentPlan, '004')

  const [uploadedFile, setUploadedFile] = useState(null)
  const [libraryDocs, setLibraryDocs] = useState([])
  const [loading, setLoading] = useState(false)
  const [trivvyEndDate, setTrivvyEndDate] = useState(null)
  const [libraryList, setLibraryList] = useState([])
  const [allowAttempts, setAllowAttempts] = useState(0)
  const [numberOfAttempts, setNumberOfAttempts] = useState(1)
  const [libraryLoaded, setLibraryLoaded] = useState(false)
  const [randomizeQuestions, setRandomizeQuestions] = useState(false)
  const [addToResource, setAddToResource] = useState(false)
  const [customTextModal, setCustomTextModal] = useState(false)
  const [currentStepperStep, setCurrentStepperStep] = useState(1)
  const [libraryLoading, setLibraryLoading] = useState(false)

  const onViewLibraryItem = async (e, item) => {
    e.preventDefault()
    if (item.text && item.librarySourceType == 2) {
      setCustomTextModal(item.text)
    } else if (item.librarySourceType == 0 && item.webUrl) {
      window.open(item.webUrl, '_blank', 'noopener,noreferrer')
    } else {
      try {
        const { data } = await axios.get(url.getSignedUrl, {
          params: { id: item._id, model: 'TriviaResource', inline: 1 },
        })
        const signedUrl = data.url
        if (!signedUrl) throw new Error('No signed URL returned')
        window.open(signedUrl, '_blank', 'noopener,noreferrer')
      } catch (err) {
        console.error('Error fetching signed URL:', err)
        window.open(item.s3Url, '_blank', 'noopener,noreferrer')
      }
    }
  }
  const [difficultyLevel, setDifficultyLevel] = useState(2)
  const [openScheduleUi, setOpenScheduleUi] = useState(false)
  const [openInviteUi, setOpenInviteUi] = useState(false)
  const [promptsCollapseOpen, setPromptsCollapseOpen] = useState(false)
  const isOwner = false
  const [allUsersChecked, setAllUsersChecked] = useState(false)

  const [usersListAll, setUsersListAll] = useState([])

  const [newSelectedUser, setNewSelectedUser] = useState(null)
  const [shareTrivvyViaSMS, setShareTrivvyViaSMS] = useState(false)
  const [shareTrivvyViaEmail, setShareTrivvyViaEmail] = useState(false)
  const [usersList, setUsersList] = useState([])
  const [usersData, setUsersData] = useState([])
  const [selectToggle, setSelectToggle] = useState('ALL')
  const [
    notifyAdminAfterTrivvyPublished,
    setNotifyAdminAfterTrivvyPublished,
  ] = useState(false)

  const [triviaShareAndPrivacy, setTriviaShareAndPrivacy] = useState({
    sharedWithUsers: [],
    privacy: 'PUBLIC',
  })

  const [userIdentification, setUserIdentification] = useState('EMAIL')
  const [libraryName, setLibraryName] = useState('')
  const [questionPreview, setQuestionPreview] = useState({
    display: false,
    data: null,
  })
  const [builtInAiQuestions, setBuiltInAiQuestions] = useState([])

  const fetchLibrary = () => {
    if (libraryLoading || libraryLoaded) return;
    setLibraryLoading(true)
    axios
      .get(url.getTriviaLibrary)
      .then(({ data }) => {
        setLibraryList(data.data)
        setLibraryDocs(data.data)
        setLibraryLoading(false)
        setLibraryLoaded(true)
      })
      .catch((err) => {
        setLibraryLoading(false)
      })
  }

  useEffect(() => {
    // if (onlyAllowCustomTextPrompt || autoSelectedTrivvyType === 'AI') {
    //   return;
    // }
    fetchLibrary()
  }, [])

  useEffect(() => {
    if (formData.uploadType === 0 && !onlyAllowCustomTextPrompt) {
      fetchLibrary()
    }
  }, [formData.uploadType])

  // Pre-select library item when passed from Library page
  // Step 1: Set triviaType and uploadType immediately so Library tab renders
  useEffect(function() {
    if (preSelectedLibraryItem && preSelectedLibraryItem._id) {
      setFormData(function(prev) {
        return { ...prev, triviaType: 1, uploadType: 0 };
      });
    }
  }, [preSelectedLibraryItem])

  // Step 2: Once library list is loaded, match and pre-select the item
  useEffect(function() {
    if (preSelectedLibraryItem && preSelectedLibraryItem._id && libraryLoaded && libraryList.length > 0) {
      var matchedItem = libraryList.find(function(lib) {
        return lib._id === preSelectedLibraryItem._id;
      });
      if (matchedItem) {
        var newFormData = {
          triviaType: 1,
          uploadType: 0,
          libraryId: matchedItem._id,
          fileUrl: '',
          uploadText: '',
          name: formData.name || '',
          questionsCount: formData.questionsCount,
          trivvyParts: formData.trivvyParts,
          noOfTrivvys: formData.noOfTrivvys,
        };
        if (matchedItem.librarySourceType == 0 && matchedItem.webUrl) {
          newFormData.fileUrl = matchedItem.webUrl;
          newFormData.libraryUploadType = 0;
        } else if (matchedItem.librarySourceType == 2 && matchedItem.text) {
          newFormData.uploadText = matchedItem.text;
          newFormData.libraryUploadType = 2;
        } else {
          newFormData.fileUrl = matchedItem.s3Url || '';
          newFormData.libraryUploadType = 1;
        }
        setFormData(newFormData);
      }
    }
  }, [preSelectedLibraryItem, libraryLoaded, libraryList])

  const formatSelectedUsers = (data) => {
    const d = data.map((e) => {
      if (e.firstName && e.lastName) {
        return {
          label: `${e.firstName}, ${e.lastName}`,
          value: e._id || e.userId,
          permissions: 0,
          profilePic: e.profilePic,
          firstName: e.firstName,
          lastName: e.lastName,
          date: e.date,
          email: e.email,
          mobileNumber: e.mobileNumber,
        }
      } else if (e) {
        let name =
          e.firstName && e.firstName.length > 0
            ? e.firstName
            : e.lastName && e.lastName.length > 0
              ? e.lastName
              : e.email
        return {
          label: `${name}`,
          value: e._id || e.userId,
          permissions: 0,
          profilePic: e.profilePic,
          firstName: e.firstName,
          lastName: e.lastName,
          date: e.date,
          email: e.email,
          mobileNumber: e.mobileNumber,
        }
      }
    })

    return d
  }

  const fetchUsers = () => {
    axios
      .get(url.userListArray)
      .then((response) => {
        setUsersData(response.data.data)
        const users = formatSelectedUsers(response.data.data)
        setUsersListAll(users)
        setUsersList(users)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    if (currentStepperStep === 2 && usersData.length === 0) {
      fetchUsers()
    }
  }, [currentStepperStep])

  const changeTrivvyName = (value, index) => {
    const partsArr = [...formData.trivvyParts]

    partsArr[index].name = value

    setFormData({
      ...formData,
      trivvyParts: partsArr,
    })
  }
  const changeTrivvyScheduledDate = (value, index) => {
    const partsArr = [...formData.trivvyParts]

    partsArr[index].scheduledDate = value

    setFormData({
      ...formData,
      trivvyParts: partsArr,
    })
  }

  const [smsUsers, setSmsUsers] = useState(0)

  const handleBuiltInAiSurveyStep = (isRegenerate) => {
    setLoading(true)
    axios
      .post(url.generateQuestionsForBuiltWithAitrivvy, {
        uploadText: formData.uploadText,
        questionsCount: formData.questionsCount * formData.noOfTrivvys,
        isRegenerate,
        oldQuestions: builtInAiQuestions,
      })
      .then(({ data }) => {
        // setLoading(false)
        const questionsArray = Array.isArray(data.data)
          ? data.data
          : Object.values(data.data)[0]
        setBuiltInAiQuestions(questionsArray)
        const formattedParts = formData.trivvyParts.map((x, idx) => ({
          ...x,
          questions: questionsArray.slice(
            idx * formData.questionsCount,
            (idx + 1) * formData.questionsCount
          ),
          id: generateRandomString(10),
        }))

        // setQuestionPreview({
        //   display: true,
        //   data: formattedParts,
        // })

        // setLoading(true)
        const users_share = triviaShareAndPrivacy.sharedWithUsers.map((itm) => {
          const user = usersData.find((x) => x._id == itm.value)
          const mediums = []

          if (user.mobileNumber && shareTrivvyViaSMS) {
            mediums.push('SMS')
          }

          if (shareTrivvyViaEmail) {
            mediums.push('EMAIL')
          }
          if (user) {
            return {
              firstName: user.firstName,
              lastName: user.lastName,
              userId: user._id,
              date: itm.date ? itm.date : new Date(),
              genderPronoun: user.genderPronoun,
              profilePic: user.profilePic,
              email: user.email,
              mobileNumber: user.mobileNumber,
              shareMediums:
                itm.shareMediums && itm.shareMediums.length > mediums.length
                  ? itm.shareMediums
                  : mediums,
            }
          } else {
            return {
              userId: itm.value,
              firstName: itm.label,
              lastName: '',
              date: itm.date ? itm.date : new Date(),
            }
          }
        })

        const getUploadType = () => {
          if (formData.triviaType === 2) {
            return null
          } else if (formData.libraryUploadType != null && formData.libraryId) {
            return formData.libraryUploadType
          } else if (formData.uploadType == 0) {
            if (
              formData.fileUrl &&
              formData.fileUrl.indexOf('s3.amazonaws.com') >= 0
            ) {
              return 1
            } else if (formData.uploadText) {
              return 2
            } else {
              return 0
            }
          } else if (formData.uploadType == 3) {
            return 0
          } else if (formData.uploadType == 2) {
            return 2
          } else {
            return 1
          }
        }
        const payload = {
          timedQuestionsEnable: false,
          difficultyLevel,
          randomizeQuestions,
          organizationName: user.profile.organizationId.name,
          notifyAdminAfterTrivvyPublished: notifyAdminAfterTrivvyPublished,
          isBuiltInWithAiType: true,
          uploadUrl:
            formData.uploadType == 0
              ? formData.fileUrl
              : generateFromLibrary
              ? formData.fileUrl
              : formData.uploadType === 3
              ? formData.fileUrl
              : null,
          uploadType: getUploadType(),
          name: formData.name,
          // triviaCategoryType:"QUIZ",
          questionsCount: formData.questionsCount,
          uploadText:
            getUploadType() == 2 || getUploadType() == 0
              ? formData.uploadText
              : null,
          generateFromLibrary: generateFromLibrary ? true : false,
          triviaType: formData.triviaType,
          resourceId: resourceId,
          trivvyEndDate: trivvyEndDate,
          allowAttempts,
          numberOfAttempts: allowAttempts == 1 ? numberOfAttempts : null,
          libraryId: generateFromLibrary
            ? preSelectedData.id
            : formData.libraryId
              ? formData.libraryId
              : undefined,
          partsArray: formData.trivvyParts.map((x) => {
            return {
              ...x,
              // isPublished:
              //   x.scheduledDate != null
              //     ? moment(x.scheduledDate).isSameOrBefore(moment(), "hour")
              //     : true,
              isPublished: false,
            }
          }),
          privacy: triviaShareAndPrivacy.privacy,
          sharedWithUsers: users_share,
          shareTrivvyViaEmail,
          shareTrivvyViaSMS,
          userIdentificationOptions: [userIdentification],
          addToResource,
          noOfTrivvys: formData.noOfTrivvys,
          libraryName,
          onlyAllowCustomTextPrompt: onlyAllowCustomTextPrompt,
        }

        axios
          .post(url.createTrivvysFinal, {
            dataToStore: payload,
            ai_questions: questionsArray,
          })
          .then(({ data }) => {
            setImportTemplateAddedTrivvys(data.data)
            toastContainer('Trivvy(s) created successfully', 'success')
            const first = data.data[0]
            if (first) {
              props.history.push(
                `/home/trivia/${first.organizationId}/edit/${first._id}/edit`
              )
            }
            onClose()
            setLoading(false)
          })
          .catch((err) => {
            setLoading(false)
            toastContainer(
              'Internal server error while generating trivvys',
              'error'
            )
          })
          .finally(() => {
            setLoading(false)
          })
      })
      .catch((err) => {
        console.log(err)
        toastContainer('Error while generating survey', 'error')
      })
  }

  const createBuilInAiSurvey = () => {
    setLoading(true)
    const users_share = triviaShareAndPrivacy.sharedWithUsers.map((itm) => {
      const user = usersData.find((x) => x._id == itm.value)
      const mediums = []

      if (user.mobileNumber && shareTrivvyViaSMS) {
        mediums.push('SMS')
      }

      if (shareTrivvyViaEmail) {
        mediums.push('EMAIL')
      }
      if (user) {
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          userId: user._id,
          date: itm.date ? itm.date : new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
          email: user.email,
          mobileNumber: user.mobileNumber,
          shareMediums:
            itm.shareMediums && itm.shareMediums.length > mediums.length
              ? itm.shareMediums
              : mediums,
        }
      } else {
        return {
          userId: itm.value,
          firstName: itm.label,
          lastName: '',
          date: itm.date ? itm.date : new Date(),
        }
      }
    })

    const getUploadType = () => {
      if (formData.triviaType === 2) {
        return null
      } else if (formData.libraryUploadType != null && formData.libraryId) {
        return formData.libraryUploadType
      } else if (formData.uploadType == 0) {
        if (
          formData.fileUrl &&
          formData.fileUrl.indexOf('s3.amazonaws.com') >= 0
        ) {
          return 1
        } else if (formData.uploadText) {
          return 2
        } else {
          return 0
        }
      } else if (formData.uploadType == 3) {
        return 0
      } else if (formData.uploadType == 2) {
        return 2
      } else {
        return 1
      }
    }
    const payload = {
      timedQuestionsEnable: false,
      difficultyLevel,
      randomizeQuestions,
      organizationName: user.profile.organizationId.name,
      notifyAdminAfterTrivvyPublished: notifyAdminAfterTrivvyPublished,
      isBuiltInWithAiType: true,
      uploadUrl:
        formData.uploadType == 0
          ? formData.fileUrl
          : generateFromLibrary
            ? formData.fileUrl
            : formData.uploadType === 3
              ? formData.fileUrl
              : null,
      uploadType: getUploadType(),
      name: formData.name,
      // triviaCategoryType:"QUIZ",
      questionsCount: formData.questionsCount,
      uploadText:
        getUploadType() == 2 || getUploadType() == 0
          ? formData.uploadText
          : null,
      generateFromLibrary: generateFromLibrary ? true : false,
      triviaType: formData.triviaType,
      resourceId: resourceId,
      trivvyEndDate: trivvyEndDate,
      allowAttempts,
      numberOfAttempts: allowAttempts == 1 ? numberOfAttempts : null,
      libraryId: generateFromLibrary
        ? preSelectedData.id
        : formData.libraryId
          ? formData.libraryId
          : undefined,
      partsArray: formData.trivvyParts.map((x) => {
        return {
          ...x,
          // isPublished:
          //   x.scheduledDate != null
          //     ? moment(x.scheduledDate).isSameOrBefore(moment(), "hour")
          //     : true,
          isPublished: false,
        }
      }),
      privacy: triviaShareAndPrivacy.privacy,
      sharedWithUsers: users_share,
      shareTrivvyViaEmail,
      shareTrivvyViaSMS,
      userIdentificationOptions: [userIdentification],
      addToResource,
      noOfTrivvys: formData.noOfTrivvys,
      libraryName,
      onlyAllowCustomTextPrompt: onlyAllowCustomTextPrompt,
    }

    axios
      .post(url.createTrivvysFinal, {
        dataToStore: payload,
        ai_questions: builtInAiQuestions,
      })
      .then(({ data }) => {
        setImportTemplateAddedTrivvys(data.data)
        toastContainer('Trivvy(s) created successfully', 'success')
        setLoading(false)
        const first = data.data[0]
        console.log({ first })
        if (first) {
          props.history.push(
            `/home/trivia/${first.organizationId}/edit/${first._id}/edit`
          )
        }

        onClose()
      })
      .catch((err) => {
        setLoading(false)
        toastContainer(
          'Internal server error while generating trivvys',
          'error'
        )
      })
  }

  const handleTryAnotherPrompt = () => {
    setQuestionPreview(false)
    setCurrentStepperStep(1)
  }

  const createSurvey = () => {
    console.log('preSelectedData', preSelectedData)
    const users_share = triviaShareAndPrivacy.sharedWithUsers.map((itm) => {
      const user = usersData.find((x) => x._id == itm.value)
      const mediums = []

      if (user.mobileNumber && shareTrivvyViaSMS) {
        mediums.push('SMS')
      }

      if (shareTrivvyViaEmail) {
        mediums.push('EMAIL')
      }
      if (user) {
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          userId: user._id,
          date: itm.date ? itm.date : new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
          email: user.email,
          mobileNumber: user.mobileNumber,
          shareMediums:
            itm.shareMediums && itm.shareMediums.length > mediums.length
              ? itm.shareMediums
              : mediums,
        }
      } else {
        return {
          userId: itm.value,
          firstName: itm.label,
          lastName: '',
          date: itm.date ? itm.date : new Date(),
        }
      }
    })

    const getUploadType = () => {
      if (formData.triviaType === 2) {
        return null
      } else if (formData.libraryUploadType != null && formData.libraryId) {
        return formData.libraryUploadType
      } else if (formData.uploadType == 0) {
        if (
          formData.fileUrl &&
          formData.fileUrl.indexOf('s3.amazonaws.com') >= 0
        ) {
          return 1
        } else if (formData.uploadText) {
          return 2
        } else {
          return 0
        }
      } else if (formData.uploadType == 3) {
        return 0
      } else if (formData.uploadType == 2) {
        return 2
      } else {
        return 1
      }
    }
    const payload = {
      difficultyLevel,
      randomizeQuestions,
      organizationName: user.profile.organizationId.name,
      notifyAdminAfterTrivvyPublished: notifyAdminAfterTrivvyPublished,
      uploadUrl:
        formData.uploadType == 0
          ? formData.fileUrl
          : generateFromLibrary
            ? formData.fileUrl
            : formData.uploadType === 3
              ? formData.fileUrl
              : null,
      uploadType: getUploadType(),
      name: formData.name,
      // triviaCategoryType:"QUIZ",
      questionsCount: formData.questionsCount,
      uploadText:
        getUploadType() == 2 || getUploadType() == 0
          ? formData.uploadText
          : null,
      generateFromLibrary: generateFromLibrary ? true : false,
      triviaType: formData.triviaType,
      resourceId: resourceId,
      trivvyEndDate: trivvyEndDate,
      allowAttempts,
      numberOfAttempts: allowAttempts == 1 ? numberOfAttempts : null,
      libraryId: generateFromLibrary
        ? preSelectedData.id
        : formData.libraryId
          ? formData.libraryId
          : undefined,
      partsArray: formData.trivvyParts.map((x) => {
        return {
          ...x,
          // isPublished:
          //   x.scheduledDate != null
          //     ? moment(x.scheduledDate).isSameOrBefore(moment(), "hour")
          //     : true,
          isPublished: false,
        }
      }),
      privacy: triviaShareAndPrivacy.privacy,
      sharedWithUsers: users_share,
      shareTrivvyViaEmail,
      shareTrivvyViaSMS,
      userIdentificationOptions: [userIdentification],
      addToResource,
      noOfTrivvys: formData.noOfTrivvys,
      libraryName,
      onlyAllowCustomTextPrompt: onlyAllowCustomTextPrompt,
    }

    const triviaForm = new FormData()

    if (uploadedFile && formData.uploadType === 1) {
      triviaForm.append('document', uploadedFile.file)
    }

    triviaForm.append('payload', JSON.stringify(payload))
    if (props.refreshLibsList && addToResource) {
      props.refreshLibsList()
    }

    setCreateTrivvyLoader({
      display: true,
      loaderApiData: {
        trivvyPartsArray: payload.partsArray,
        triviaForm,
        payload: payload,
      },
      minimize: false,
      embeddedInTrivvyCreateModal: true,
    })
    onClose()

  }

  useEffect(() => {
    console.log('autoSelectedTrivvyType -- ', autoSelectedTrivvyType)
    if (preSelectedData) {
      console.log(preSelectedData)
      if (preSelectedData.s3Url) {
        setFormData({
          ...formData,
          uploadType: 1,
          fileUrl: preSelectedData.s3Url,
          triviaType: 1,
          name: preSelectedData.name,
        })
      } else if (preSelectedData.libText) {
        setFormData({
          ...formData,
          uploadType: 2,
          fileUrl: '',
          uploadText: preSelectedData.libText,
          triviaType: 1,
          name: preSelectedData.name,
        })
      } else if (preSelectedData.webUrl) {
        setFormData({
          ...formData,
          uploadType: 0,
          fileUrl: preSelectedData.webUrl,
          triviaType: 1,
          name: preSelectedData.name,
        })
      } else if (preSelectedData.selectedPrompt) {
        setFormData({
          ...formData,
          uploadType: 2,
          uploadText: preSelectedData.selectedPrompt,
          triviaType: 1,
        })
      }
    } else {
      if (autoSelectedTrivvyType == 'CUSTOM') {
        console.log('custom ----  618')
        setFormData({
          ...formData,
          triviaType: 2,
        })
      }
      if (autoSelectedTrivvyType == 'AI') {
        setFormData({
          ...formData,
          triviaType: 1,
          uploadType: onlyAllowCustomTextPrompt ? 2 : null,
        })
      }
    }
  }, [])

  const handleFileUpload = (e) => {
    setUploadedFile(e.target.files[0])
  }

  const step1Enabled = () => {
    let errors = []

    console.log('713 inside- ----')
    let bool = true

    if (!formData.name) {
      errors.push('Please enter Name')
      bool = false
    }

    if (!formData.questionsCount) {
      errors.push('Please enter no of questions')
      bool = false
    }

    // if (!formData.noOfTrivvys) {
    //   errors.push('Please enter no of trivvys.')
    //   bool = false
    // }

    if (!isEnterprisePlan) {
      setFormData(prev => ({
        ...prev,
        noOfTrivvys: 1,
        trivvyParts: prev.trivvyParts.length
          ? prev.trivvyParts.slice(0, 1)
          : [{
            name: `${prev.name || ''}`,
            scheduledDate: null,
            privacy: 'PUBLIC',
            sharedWithUsers: [],
          }],
      }));
    } else {
      if (!formData.noOfTrivvys) {
        errors.push('Please enter no of trivvys.');
        bool = false
      }
    }

    if (!generateFromLibrary) {
      if (formData.uploadType === null && !onlyAllowCustomTextPrompt) {
        errors.push('Please select content type')
        bool = false
      }

      if (formData.uploadType == 0) {
        if (!formData.libraryId) {
          errors.push('Please select library')
          bool = false
        }
      }

      if (formData.uploadType == 1) {
        if (
          uploadedFile &&
          uploadedFile.file &&
          uploadedFile.file.type &&
          (uploadedFile.file.type.indexOf('csv') >= 0 ||
            uploadedFile.file.type.indexOf('pdf') >= 0 ||
            uploadedFile.file.type.indexOf('word') >= 0 ||
            uploadedFile.file.type.indexOf('text') >= 0)
        ) {
        } else {
          errors.push('Please select valid CSV/PDF/Text file')
          bool = false
        }
      }

      if (formData.uploadType == 2) {
        if (!formData.uploadText) {
          bool = false
          errors.push('Please enter custom text')
        }
        if (formData.uploadText.length && formData.uploadText.length < 40) {
          errors.push('Custom text must be at least 40 characters')
          bool = false
        }
      }

      if (formData.uploadType == 3) {
        if (!isUrlValid(formData.fileUrl)) {
          bool = false
          errors.push('Please enter valid url')
        }
      }
    }

    setErrorsArr(errors)

    return bool
  }

  const step2Enabled = () => {
    let bool = true
    if (
      triviaShareAndPrivacy.privacy == 'CUSTOM' &&
      !triviaShareAndPrivacy.sharedWithUsers.length
    ) {
      bool = false
    } else if (
      triviaShareAndPrivacy.sharedWithUsers.length > 0 &&
      !shareTrivvyViaEmail &&
      !shareTrivvyViaSMS
    ) {
      bool = false
    }

    return bool
  }

  const fileSelectedHandler = (e) => {
    const file = e.target.files[0]
    if (file) {
      if (trivvyFileTypeCheck(file.type)) {
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          datetime: Date.now().toString(),
          // blob: URL.createObjectURL(file),
          preview: URL.createObjectURL(file),
        }
        setUploadedFile(uploadPreview(obj))
      } else {
        toastContainer('Please upload Pdf or Docx or Txt file.', 'error')
      }
    }
  }

  const renderUploadPreview = () => {
    let photo = uploadedFile
    let { preview, size } = photo
    preview = preview != null && preview != undefined ? preview : photo.url
    let mb = 1024 * 1024
    let file_size =
      size >= mb
        ? `${(size / mb).toFixed(2)}mb`
        : `${(size / 1024).toFixed(2)}kb`
    return (
      <span
        className={
          photo.isAccepted == false
            ? 'taskUploadPreviewImg rejectedFilesContainer'
            : 'taskUploadPreviewImg'
        }>
        <img 
          src={preview} 
          className="fileUploadSize"
          style={isMobile ? { width: '60px', height: '60px' } : {}}
        />
        <span
          onClick={() => setUploadedFile(null)}
          className="removeTaskUpload">
          <span className="flaticon-trash" />
        </span>
        <div className="previewTaskImageText width-ellipis-text-file">
          <span 
            className="" 
            style={isMobile ? { 
              fontSize: '11px',
              display: 'block',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            } : {
              display: 'block',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
            title={photo.name}>
            {photo.name}
          </span>
        </div>
      </span>
    )
  }

  const getValueForAttemptDD = () => {
    if (allowAttempts == 0) {
      return 'NO'
    } else if (allowAttempts == 2) {
      return 'MANY'
    } else if (allowAttempts == 1) {
      return numberOfAttempts
    }
  }

  const onUserSelect = (u) => {
    setNewSelectedUser(u)

    if (u && u.mobileNumber && u.mobileNumber.length > 0) {
      let userCellCount = smsUsers + 1
      setSmsUsers(userCellCount)
    }

    const array = [u, ...triviaShareAndPrivacy.sharedWithUsers]
    if (u) {
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: array,
      })
    }
  }

  const removeUser = (id, mobileNumber) => {
    const users = [...triviaShareAndPrivacy.sharedWithUsers]

    const newUsers = users.filter((x) => x.value != id)
    if (mobileNumber && mobileNumber.length > 0) {
      let userCellCount = smsUsers == 0 ? 0 : smsUsers - 1
      setSmsUsers(userCellCount)
    }

    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: [...newUsers],
    })

    // callApiToSaveData(newUsers, "REMOVE");
  }

  const onUserSelectAll = (u) => {
    if (u) {
      const onlySMSUsers = [...usersList].filter(
        (x) => x.mobileNumber && x.mobileNumber.length > 0
      )
      setSmsUsers(onlySMSUsers.length)
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: usersList,
      })
    } else {
      setSmsUsers(0)
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: [],
      })
    }
  }

  const viewMember = (u) => {
    let link = `/home/${user.profile.organizationId._id}/profile/${u.value}`
    props.history.push(link)
  }

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : 'N'
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : 'N'
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
  }

  const modifyCustomText = (value) => {
    setFormData({
      ...formData,
      uploadText: value,
    })
  }

  const tableCols = {
    user: shareTrivvyViaSMS ? 3 : 5,
    date: 3,
    action: 2,
    phoneNumber: 2,
    sharedVia: 2,
  }

  const { privacy, sharedWithUsers } = triviaShareAndPrivacy


  const modalUi = () => {
    if (questionPreview && questionPreview.display && questionPreview.data) {
      return (
        <QuestionPreviewStep
          loading={loading}
          partsData={questionPreview.data}
          handleTryAgain={handleTryAnotherPrompt}
          handleContinue={createBuilInAiSurvey}
          customText={formData.uploadText}
          modifyCustomText={modifyCustomText}
          handleGenerateAgain={() => handleBuiltInAiSurveyStep(true)}
        />
      )
    } else {
      return (
        <div className="createTriviaPopupContainer">
          {!onlyAllowCustomTextPrompt && (
            <Steps
              steps={['Generate data', 'Sharing', 'Other settings']}
              currentStep={currentStepperStep}
            />
          )}

          {/* Basic config UI */}
          {currentStepperStep == 1 ? (
            <div className="createTriviaPopupContainerUi1">
              {customTextModal && (
                <Modal isOpen={true}>
                  <ModalHeader
                    toggle={() => {
                      setCustomTextModal(false)
                    }}
                    className="trivia_modal_header_bg">
                    Custom Text
                  </ModalHeader>
                  <ModalBody>{customTextModal}</ModalBody>
                </Modal>
              )}
              {!generateFromLibrary && !autoSelectedTrivvyType && (
                <div className="my-3">
                  <Label>Trivvy Type</Label>
                  <Select
                    value={formData.triviaType}
                    onChange={(e) => {
                      setFormData({ ...formData, triviaType: e.value })
                    }}
                    options={triviaTypeOptions}
                    placeholder="Select Trivvy type."
                  />
                </div>
              )}

              <div className="my-3">
                <Label>Name*</Label>
                <Input
                  onChange={(e) => {
                    // const newPartsFromat = formData.trivvyParts.map(
                    //   (x, idx) => {
                    //     return {
                    //       ...x,
                    //       name: `${e.target.value || ''} Part - ${idx + 1}`,
                    //     }
                    //   }
                    // )

                    const newPartsFormat = formData.trivvyParts.map(
                      (x, idx) => {
                        const hasMultipleParts = formData.trivvyParts.length > 1
                        return {
                          ...x,
                          name: `${e.target.value || ''}${hasMultipleParts || formData.noOfTrivvys > 1
                            ? ` Part - ${idx + 1}`
                            : ''
                            }`,
                        }
                      }
                    )
                    setFormData({
                      ...formData,
                      name: e.target.value,
                      trivvyParts: newPartsFormat,
                    })
                  }}
                  value={formData.name}
                  placeholder="Please enter a name"
                />
              </div>

              {onlyAllowCustomTextPrompt ? (
                <div className="">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div>
                        <span>Show Sample Prompts</span>
                      </div>
                    </div>

                    <div>
                      {promptsCollapseOpen ? (
                        <BiCaretUp
                          onClick={() => {
                            setPromptsCollapseOpen(false)
                          }}
                        />
                      ) : (
                        <BiCaretDown
                          onClick={() => {
                            setPromptsCollapseOpen(true)
                          }}
                        />
                      )}
                    </div>
                  </div>

                  <Collapse isOpen={promptsCollapseOpen}>
                    <div className="bwai-txt-container">
                      <div className="mx-0 px-0 d-flex">
                        {BUILT_WITH_AI_PROMPTS_STANDARD.map((prompt) => {
                          return (
                            <Col md={4} xs={12} className="mt-3">
                              <BuildAithAiCard
                                title={prompt.title}
                                description={prompt.description}
                                handleSelect={() => {
                                  setFormData({
                                    ...formData,
                                    uploadText: prompt.description,
                                  })
                                }}
                              />
                            </Col>
                          )
                        })}
                      </div>
                    </div>
                  </Collapse>

                  {/* {formData.uploadText && formData.uploadText.length < 40 ? (
                    <Alert color={"danger"}>
                      Your custom input must be greater than 40 characters.
                    </Alert>
                  ) : (
                    ""
                  )} */}
                  <span className="bwai-txtarea-desc mt-3">
                    **Tell us what you want to find out. Please note you’ll get
                    a better survey, the more specific you can be{' '}
                    <span className="language-support-text">
                      (1000 characters max, no less than 40 characters.)
                    </span>{' '}
                  </span>
                  <textarea
                    value={formData.uploadText}
                    onChange={(e) => {
                      let val = e.target.value

                      setFormData({
                        ...formData,
                        uploadText: val.slice(0, 1000),
                      })
                    }}
                    rows={8}
                    className="w-100"
                    placeholder="Type in what you need to find out"
                  />
                  {formData.uploadText ? (
                    <small className="float-right">
                      {formData.uploadText.length}/1000
                    </small>
                  ) : (
                    ''
                  )}

                  <small className="language-support-text">
                    Tip: start from example prompt or write your own based on
                    our guidelines{' '}
                    <OoPopover
                      target="popover_built_with_ai_prompt"
                      css_class="popover_built_with_ai_prompt_css"
                      headerText="Help with prompts"
                      bodyText={
                        <ul>
                          <li>
                            <b>State your goal</b> : Whether you are looking to
                            improve customer or employee experiences, gauge
                            brand perception, or just gain general insights on a
                            range of topics related to your market, you’ll want
                            to clearly state your end goal within your prompt.
                            Example: “I need to gauge the sentiments from
                            current customers around the rebrand of our new
                            eco-friendly brand of clothing made of recycled
                            materials.”
                          </li>
                          <li>
                            <b>Explain what you want to know</b>: In order to
                            meet that goal, you’ll want to identify the types of
                            questions you want to include in your survey that
                            will give you the insights you need. It’s a good
                            idea to include specific areas that you want your
                            survey to focus on and exact outcomes you’d like to
                            see from it. Example: "I’ll want to ask questions
                            that identify which factors are most important to
                            customers, such as price, style, convenience,
                            quality, and transparent sourcing."
                          </li>
                          <li>
                            <b>Describe your audience</b>: Specify audience
                            demographics that you need to know in terms of age,
                            gender, education level, professional background,
                            country of residence, etc. Example: "Please include
                            questions that ask for the age, income level, and
                            nationality of respondents."
                          </li>
                          <li>
                            <b>Define structure</b>: If you need specific
                            question types (multiple choice, open-ended, Likert
                            scale) or are looking for specific responses around
                            customer experience metrics like customer
                            satisfaction (CSAT) or Net Promoter Score (NPS®),
                            specify these details in your prompt for the best
                            results. Example: "Please use an open-ended question
                            asking why the respondent felt that way after a
                            Likert scale question."
                          </li>
                        </ul>
                      }
                    />
                  </small>
                </div>
              ) : (
                ''
              )}

              {!generateFromLibrary &&
                formData.triviaType == 1 &&
                !onlyAllowCustomTextPrompt && (
                  <div className="my-3">
                    <Label className={'mb-0'}>..</Label>
                    {minPlanLimitCheck(currentPaymentPlan, '002') ? (
                      <SupportedLanguagesText showDataTrivvytext />
                    ) : (
                      <div className="language-support-text">
                        Data source must be in English and if other laguages
                        needed then please upgrade your plan.
                      </div>
                    )}

                    <SourceSelector
                      totalLibraryItems={libraryList.length}
                      selectedSource={formData.uploadType}
                      onSelectSource={(val) => {
                        setLibraryDocs(libraryList)
                        setFormData({
                          ...formData,
                          uploadType: val,
                          ...(val === 3 ? { fileUrl: '' } : {}),
                          ...(val !== 0 ? { libraryId: undefined, libraryUploadType: undefined } : {}),
                        })
                      }}
                    />


                  </div>
                )}

              {!generateFromLibrary &&
                formData.triviaType == 1 &&
                !onlyAllowCustomTextPrompt && (
                  <div>
                    {formData.uploadType === 0 ? (
                      <div className="mt-3 table-style-design-scroll">
                        <Label>
                          Library*{' '}
                          {libraryList.length === 0 ? (
                            <span
                              style={{ opacity: '0.5', marginLeft: '10px' }}>
                              (No items in library)
                            </span>
                          ) : (
                            ''
                          )}{' '}
                        </Label>
                        <Input
                          className="custom-w-70"
                          disabled={libraryList.length === 0}
                          onChange={(e) => {
                            const value =
                              e.target.value && e.target.value.trim()
                            const libDocs = [...libraryDocs]
                            if (value) {
                              const filtered = libDocs.filter(
                                (x) =>
                                  getTriviaFileName({
                                    uploadUrl: x.s3Url,
                                    uploadFileName: x.s3Key,
                                    clip: true,
                                    librarySourceType: x.librarySourceType,
                                    libName: x.name,
                                    webUrl: x.webUrl,
                                  }) &&
                                  getTriviaFileName({
                                    uploadUrl: x.s3Url,
                                    uploadFileName: x.s3Key,
                                    clip: true,
                                    librarySourceType: x.librarySourceType,
                                    libName: x.name,
                                    webUrl: x.webUrl,
                                  })
                                    .toLowerCase()
                                    .indexOf(value.toLowerCase()) > -1
                              )

                              setLibraryDocs(filtered)
                            } else {
                              setLibraryDocs(libraryList)
                            }
                          }}
                          placeholder="Type to search..."
                        />
                        <Table>
                          <tr className="table-fixed-header">
                            <th>Name</th>
                            <th>Type</th>
                          </tr>

                          {libraryDocs && libraryDocs.length > 0 ? (
                            libraryDocs.map((x) => {
                              const checked = formData.libraryId === x._id
                              return (
                                <tr
                                  className={
                                    checked
                                      ? 'tr_create_trivia_selected cursor-pointer'
                                      : 'cursor-pointer'
                                  }
                                  onClick={() => {
                                    if (checked) {
                                      setFormData({
                                        ...formData,
                                        fileUrl: '',
                                        uploadType: 0,
                                        libraryId: undefined,
                                        uploadText: '',
                                      })
                                    } else {
                                      if (
                                        x.librarySourceType == 0 &&
                                        x.webUrl
                                      ) {
                                        setFormData({
                                          ...formData,
                                          fileUrl: x.webUrl,
                                          uploadText: '',
                                          uploadType: 0,
                                          libraryId: x._id,
                                          libraryUploadType: 0,
                                        })
                                      } else if (
                                        x.librarySourceType == 2 &&
                                        x.text
                                      ) {
                                        setFormData({
                                          ...formData,
                                          fileUrl: '',
                                          uploadType: 0,
                                          libraryId: x._id,
                                          uploadText: x.text,
                                          libraryUploadType: 2,
                                        })
                                      } else {
                                        setFormData({
                                          ...formData,
                                          fileUrl: x.s3Url,
                                          uploadType: 0,
                                          libraryId: x._id,
                                          uploadText: '',
                                          libraryUploadType: 1,
                                        })
                                      }
                                    }
                                  }}>
                                  <td
                                    style={{
                                      width: '70%',
                                      borderTop: 'none',
                                    }}>
                                    {getTriviaFileName({
                                      uploadUrl: x.s3Url,
                                      uploadFileName: x.s3Key,
                                      clip: true,
                                      librarySourceType: x.librarySourceType,
                                      libName: x.name,
                                      webUrl: x.webUrl,
                                    })}
                                    <a
                                      href="#"
                                      style={{ color: '#207DE9' }}
                                      onClick={(e) => onViewLibraryItem(e, x)}
                                      rel="noopener noreferrer">
                                      (View)
                                    </a>
                                  </td>
                                  <td style={{ borderTop: 'none' }}>
                                    {x.s3Url
                                      ? getFileTypeFromUrl(x.s3Url)
                                      : x.webUrl
                                        ? 'Webpage'
                                        : 'Custom Text'}
                                  </td>
                                </tr>
                              )
                            })
                          ) : (
                            <div className="text-center">
                              {libraryLoading
                                ? 'Retriving your library resources.'
                                : 'No results found.'}
                            </div>
                          )}
                        </Table>
                      </div>
                    ) : formData.uploadType === 1 ? (
                      <div className="mt-3">
                        {uploadedFile && renderUploadPreview()}
                        <div className={`singleTaskUploadModalBtn ${isMobile ? 'd-block' : 'd-flex align-items-center'}`}>
                          <label
                            htmlFor="profile-pic-file-input"
                            style={{ 
                              marginBottom: '0px',
                              cursor: 'pointer'
                            }}>
                            <span
                              style={{ 
                                color: '#007bff',
                                textDecoration: 'underline',
                                fontSize: isMobile ? '14px' : '16px',
                                cursor: 'pointer',
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                display: 'inline'
                              }}>
                              {uploadedFile ? 'Upload a different file' : 'Choose file'}
                            </span>
                          </label>
                          <div className={`${isMobile ? 'mt-2' : 'my-2 ml-1'} allowedFilesLabel`}
                               style={isMobile ? { fontSize: '11px' } : {}}>
                            (*Allowed files Pdf, Docx or Txt up to 20mb)
                          </div>
                          <input
                            id="profile-pic-file-input"
                            onChange={fileSelectedHandler}
                            type="file"
                            accept=".pdf,.doc,.docx,.txt"
                          />
                        </div>
                      </div>
                    ) : formData.uploadType === 3 ? (
                      <div>
                        <Label>Website url*</Label>
                        <Input
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              fileUrl: e.target.value,
                            })
                          }}
                          value={formData.fileUrl}
                          placeholder="Enter website url"
                        />
                      </div>
                    ) : formData.uploadType === 2 ? (
                      <div className="mt-3">
                        <Label>
                          Custom text*{' '}
                          <span className="allowedFilesLabel">
                            {' '}
                            (Type or cut and paste)
                          </span>
                        </Label>
                        <textarea
                          value={formData.uploadText}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              uploadText: e.target.value,
                            })
                          }}
                          rows={8}
                          className="w-100"
                          placeholder="Enter text for generating questions"
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                )}

              {/* {!onlyAllowCustomTextPrompt &&
                !generateFromLibrary &&
                formData.triviaType == 1 &&
                formData.uploadType != 0 &&
                ((formData.uploadType === 1 && uploadedFile) ||
                  (formData.uploadType === 2 && formData.uploadText) ||
                  (formData.uploadType === 3 && formData.fileUrl)) && (
                  <div className="mt-4 mb-2">
                    <CheckBox
                      checked={addToResource}
                      onChange={(e) => {
                        setAddToResource(e.target.checked)
                      }}
                    />{' '}
                    <span className="ml-2">Add to library</span>
                  </div>
                )} */}

              {/* {addToResource && (
                <div>
                  <div className="mb-2">
                    (Optional) Add library item name or default to data source
                    name
                  </div>
                  <Input
                    className="bottom-border-input"
                    value={libraryName}
                    onChange={(e) => setLibraryName(e.target.value)}
                    placeholder="Please enter a name"
                  />
                </div>
              )} */}

              <div className="my-3">
                <Label>
                  {onlyAllowCustomTextPrompt
                    ? 'How many questions do you want your Trivvy to be?*'
                    : 'How many questions do you want per Trivvy?*'}{' '}
                  <small className="font-weight-bold">
                    note: you can only select up to 5 questions
                  </small>{' '}
                </Label>
                <Select
                  value={formData.questionsCount}
                  onChange={(e) => {
                    setFormData({ ...formData, questionsCount: e.value })
                  }}
                  options={questionOptions}
                  placeholder="Select number of questions..."
                />
              </div>

              {formData.triviaType === 1 && (
                <div className="mt-3">
                  {!onlyAllowCustomTextPrompt && (
                    <div className="my-2">
                      <Label>
                        {isEnterprisePlan ? (
                          'How many trivvys should be generated?*'
                        ) : (
                          <span style={{ color: 'grey' }}>
                            Auto-generate multiple trivvys
                            {/* <UpgradeTag text="Upgrade" /> */}
                            <a
                              href="https://www.ouroffice.io/meet"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                backgroundColor: '#ff4500',
                                color: 'white',
                                padding: '2px 8px',
                                borderRadius: '4px',
                                textDecoration: 'none',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                marginLeft: '8px'
                              }}
                            >
                              Upgrade
                            </a>
                          </span>
                        )}{' '}
                        {!formData.questionsCount && isEnterprisePlan ? (
                          <small className="font-weight-bold">
                            (Note: Please select number of questions first)
                          </small>
                        ) : null}
                      </Label>
                      {isEnterprisePlan &&
                        <Select
                          isDisabled={
                            formData.questionsCount == null && isEnterprisePlan
                          }
                          placeholder={
                            isEnterprisePlan
                              ? 'Select...'
                              : 'Must Upgrade to Enterprise Plan'
                          }
                          disabled={formData.questionsCount == null}
                          isReadOnly={formData.questionsCount == null}
                          value={formData.noOfTrivvys}
                          options={
                            formData.questionsCount
                              ? SELECT_NO_OF_TRIVVYS(
                                Math.floor(20 / formData.questionsCount)
                              )
                              : 0
                          }
                          onChange={(e) => {
                            if (e) {
                              const array = Array(e.value)
                                .fill()
                                .map((x, idx) => ({
                                  name: `${formData.name}${e.value > 1 ? ` Part - ${idx + 1}` : ''}`,
                                  scheduledDate: null,
                                  privacy: 'PUBLIC',
                                  sharedWithUsers: [],
                                }))
                              setFormData({
                                ...formData,
                                noOfTrivvys: e.value,
                                trivvyParts: array,
                              })
                            } else {
                              setFormData({
                                ...formData,
                                noOfTrivvys: null,
                              })
                            }
                          }}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              border: !isEnterprisePlan
                                ? 'dashed'
                                : provided.border,
                              backgroundColor: !isEnterprisePlan
                                ? '#F9FAFB'
                                : provided.backgroundColor,
                              borderColor: !isEnterprisePlan
                                ? '#D1D5DB'
                                : provided.borderColor,
                              ...(state.isDisabled && { opacity: 0.6 }), // Maintain disabled appearance
                            }),
                          }}
                        />
                      }
                    </div>
                  )}

                  {formData.noOfTrivvys ? (
                    <div className="my-3">
                      <div className="mb-2">
                        {/* <Label
                          className={
                            formData.noOfTrivvys
                              ? 'd-flex justify-content-between'
                              : ''
                          }>
                          {onlyAllowCustomTextPrompt
                            ? 'Do you want to schedule your trivvy for a future date? (Click here)'
                            : 'Do you want to schedule your trivvys now?'}{' '}

                          <span className="mr-1 cursor-pointer">
                            {openScheduleUi ? (
                              <BiCaretUp
                                size={25}
                                onClick={() => {
                                  setOpenScheduleUi(!openScheduleUi)
                                }}
                              />
                            ) : (
                              <BiCaretDown
                                size={25}
                                onClick={() => {
                                  setOpenScheduleUi(!openScheduleUi)
                                }}
                              />
                            )}
                          </span>
                        </Label> */}

                        <Label
                          className={
                            formData.noOfTrivvys
                              ? 'd-flex justify-content-between'
                              : ''
                          }
                          style={{
                            color: isEnterprisePlan ? 'inherit' : '#6a6363ab',
                            cursor: isEnterprisePlan
                              ? 'pointer'
                              : 'not-allowed',
                            flexDirection: 'column',
                          }}>
                          {isEnterprisePlan ? (
                            onlyAllowCustomTextPrompt ? (
                              'Do you want to schedule your Trivvy for a future date? (Click here)'
                            ) : (
                              'Do you want to schedule your trivvys now?'
                            )
                          ) : (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                              }}>
                              <p>
                                {' '}
                                Auto schedule your trivvys{' '}
                                <UpgradeTag text="Upgrade" />
                              </p>
                            </div>
                          )}

                          {isEnterprisePlan && (
                            <span className="mr-1 cursor-pointer">
                              {openScheduleUi ? (
                                <BiCaretUp
                                  size={25}
                                  onClick={() =>
                                    setOpenScheduleUi(!openScheduleUi)
                                  }
                                />
                              ) : (
                                <BiCaretDown
                                  size={25}
                                  onClick={() =>
                                    setOpenScheduleUi(!openScheduleUi)
                                  }
                                />
                              )}
                            </span>
                          )}
                        </Label>
                      </div>

                      {/* <Collapse isOpen={openScheduleUi}>
                        <div
                          style={{
                            color: '#6a6363ab',
                          }}>
                          Note: Trivvy(s) needs to be published to be sent on the
                          scheduled date(s) below. If you would like to review your
                          Trivvy(s) before being sent, leave the <b>scheduled date</b> blank.
                        </div>

                        {formData.trivvyParts && formData.trivvyParts.length ? (
                          <div>
                            <Row className="mt-3">
                              <Col md={7} xs={6}>
                                <b>Name</b>
                              </Col>

                              <Col md={5} xs={6}>
                                <b>Scheduled Date (Optional)</b>
                              </Col>
                            </Row>
                            {formData.trivvyParts.map((item, index) => {
                              return (
                                <Row className="my-3">
                                  <Col md={7} xs={6}>
                                    <div className="d-flex align-items-center">
                                      <Input
                                        value={item.name}
                                        onChange={(e) => {
                                          changeTrivvyName(
                                            e.target.value,
                                            index
                                          )
                                        }}
                                        placeholder={`Part ${index +
                                          1}(Add trivvy name)`}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={5} xs={6}>
                                    <ReactDatePicker
                                      dateFormat="MM/DD/YYYY 𝖺𝗍 h:mm a"
                                      id="actionDueDate"
                                      placeholderText="Enter date: MM/DD/YYYY"
                                      className="form-control filter-action-date-input"
                                      minDate={new Date()}
                                      minTime={
                                        item.scheduledDate
                                          ? moment().isSame(
                                              moment(item.scheduledDate),
                                              'day'
                                            )
                                            ? moment()
                                            : moment().startOf('day')
                                          : moment()
                                      }
                                      maxTime={moment().endOf('day')}
                                      selected={
                                        typeof item.scheduledDate == 'string'
                                          ? moment(item.scheduledDate)
                                          : item.scheduledDate
                                      }
                                      onChange={(v) => {
                                        if (v) {
                                          let date = moment(v)

                                          if (
                                            moment()
                                              .startOf('day')
                                              .isSame(date, 'hour')
                                          ) {
                                            changeTrivvyScheduledDate(
                                              moment()
                                                .endOf('hour')
                                                .add(1, 'minute'),
                                              index
                                            )
                                          } else {
                                            if (
                                              moment(date)
                                                .startOf('day')
                                                .isSame(date, 'hour')
                                            ) {
                                              changeTrivvyScheduledDate(
                                                date.add(9, 'hours'),
                                                index
                                              )
                                            } else {
                                              changeTrivvyScheduledDate(
                                                date,
                                                index
                                              )
                                            }
                                          }
                                        } else {
                                          changeTrivvyScheduledDate(null, index)
                                        }
                                      }}
                                      showYearDropdown
                                      showTimeSelect
                                      timeFormat="h:mm a"
                                      timeIntervals={60}
                                    />
                                  </Col>

                                  {index != formData.noOfTrivvys - 1 && (
                                    <hr className="my-2" />
                                  )}
                                </Row>
                              )
                            })}
                          </div>
                        ) : (
                          ''
                        )}

                        <div className="my-3">
                          <Label>Notify me when trivvys are published</Label>
                          <CheckBox
                            className="ml-3"
                            checked={notifyAdminAfterTrivvyPublished}
                            onChange={(e) => {
                              setNotifyAdminAfterTrivvyPublished(
                                e.target.checked
                              )
                            }}
                          />
                        </div>
                      </Collapse> */}

                      <Collapse isOpen={openScheduleUi}>
                        <div
                          style={{
                            opacity: isEnterprisePlan ? 1 : 0.5,
                            pointerEvents: isEnterprisePlan ? 'auto' : 'none',
                          }}>
                          <div style={{ color: '#6a6363ab' }}>
                            Note: Trivvy(s) needs to be published to be sent on the
                            scheduled date(s) below. If you would like to review your
                            Trivvy(s) before being sent, leave the <b>scheduled date</b> blank.
                          </div>

                          {formData.trivvyParts &&
                            formData.trivvyParts.length ? (
                            <div>
                              <Row className="mt-3">
                                <Col md={7} xs={6}>
                                  <b>Name</b>
                                </Col>
                                <Col md={5} xs={6}>
                                  <b>Scheduled Date (Optional)</b>
                                </Col>
                              </Row>

                              {formData.trivvyParts.map((item, index) => (
                                <Row className="my-3" key={index}>
                                  <Col md={7} xs={6}>
                                    <div className="d-flex align-items-center">
                                      <Input
                                        value={item.name}
                                        onChange={(e) =>
                                          changeTrivvyName(
                                            e.target.value,
                                            index
                                          )
                                        }
                                        placeholder={`Part ${index +
                                          1}(Add Trivvy name)`}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={5} xs={6}>
                                    <ReactDatePicker
                                      dateFormat="MM/DD/YYYY 𝖺𝗍 h:mm a"
                                      id="actionDueDate"
                                      placeholderText="Enter date: MM/DD/YYYY"
                                      className="form-control filter-action-date-input"
                                      minDate={new Date()}
                                      minTime={
                                        item.scheduledDate
                                          ? moment().isSame(
                                            moment(item.scheduledDate),
                                            'day'
                                          )
                                            ? moment()
                                            : moment().startOf('day')
                                          : moment()
                                      }
                                      maxTime={moment().endOf('day')}
                                      selected={
                                        typeof item.scheduledDate === 'string'
                                          ? moment(item.scheduledDate).toDate()
                                          : item.scheduledDate
                                      }
                                      onChange={(v) => {
                                        if (v) {
                                          const date = moment(v)
                                          if (
                                            moment()
                                              .startOf('day')
                                              .isSame(date, 'hour')
                                          ) {
                                            // Today @ midnight selected: bump to the next full hour (TBV-624: 00 min, 00 sec)
                                            changeTrivvyScheduledDate(
                                              moment()
                                                .add(1, 'hour')
                                                .startOf('hour'),
                                              index
                                            )
                                          } else if (
                                            moment(date)
                                              .startOf('day')
                                              .isSame(date, 'hour')
                                          ) {
                                            // Future day @ midnight selected: default to 09:00:00
                                            changeTrivvyScheduledDate(
                                              date.add(9, 'hours').startOf('hour'),
                                              index
                                            )
                                          } else {
                                            // Snap to the nearest quarter-hour (TBV: quarter-hour scheduling)
                                            changeTrivvyScheduledDate(
                                              snapToQuarterHour(date),
                                              index
                                            )
                                          }
                                        } else {
                                          changeTrivvyScheduledDate(null, index)
                                        }
                                      }}
                                      showYearDropdown
                                      showTimeSelect
                                      timeFormat="h:mm a"
                                      timeIntervals={15}
                                    />
                                  </Col>

                                  {index !== formData.noOfTrivvys - 1 && (
                                    <hr className="my-2" />
                                  )}
                                </Row>
                              ))}
                            </div>
                          ) : (
                            ''
                          )}

                          <div className="my-3">
                            <Label>Notify me when trivvys are published</Label>
                            <CheckBox
                              className="ml-3"
                              checked={notifyAdminAfterTrivvyPublished}
                              onChange={(e) => {
                                setNotifyAdminAfterTrivvyPublished(
                                  e.target.checked
                                )
                              }}
                            />
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              )}
            </div>
          ) : currentStepperStep == 2 ? (
            <div className="createTriviaPopupContainerUi2">
              <div>
                {formData.triviaType == 1 && (
                  <div className="my-3">
                    <div className="">
                      <div>
                        <Row className={`mt-4 share-quiz-privacy`}>
                          <Col md={6}>
                            <div className="row text-left my-3">
                              <div className="col-md-5 col-lg-5 text-left sharePer-trivvy-txt">
                                Sharing Permissions:
                              </div>
                              <div className="col-md-7 col-lg-7 enterprise-settings-value">
                                <Select
                                  className="pt-0"
                                  value={triviaShareAndPrivacy.privacy}
                                  onChange={(val) => {
                                    setTriviaShareAndPrivacy({
                                      ...triviaShareAndPrivacy,
                                      privacy: val.value,
                                    })
                                  }}
                                  options={TRIVIA_SHARE_PRIVACY_OPTIONS}
                                  placeholder="Select Privacy"
                                />
                              </div>
                            </div>
                          </Col>

                          <Col md={6}>
                            {triviaShareAndPrivacy.privacy == 'PUBLIC' && (
                              <div>
                                <div className="row text-left my-3">
                                  <div className="col-md-5 col-lg-5 text-left">
                                    User must provide:
                                  </div>
                                  <div className="col-md-7 col-lg-7 enterprise-settings-value">
                                    <Select
                                      className="pt-0"
                                      value={userIdentification}
                                      onChange={(val) => {
                                        setUserIdentification(val.value)
                                      }}
                                      options={
                                        TRIVIA_USER_IDENTIFICATION_OPTIONS
                                      }
                                      placeholder="Select User Identification"
                                    />{' '}
                                  </div>
                                </div>

                                <ReactTooltip />
                              </div>
                            )}
                          </Col>
                        </Row>
                      </div>

                      {/* <div className={`mt-4`}>
                        <div className="dFelxCenterWithGap justify-content-between">
                          {' '}
                          <h6>Invite Platform Users</h6>{' '}
                          <span className="mr-1 cursor-pointer">
                            {openInviteUi ? (
                              <BiCaretUp
                                size={25}
                                onClick={() => {
                                  setOpenInviteUi(!openInviteUi)
                                }}
                              />
                            ) : (
                              <BiCaretDown
                                size={25}
                                onClick={() => {
                                  setOpenInviteUi(!openInviteUi)
                                }}
                              />
                            )}
                          </span>
                        </div>

                        <Collapse isOpen={openInviteUi}>
                          <div className={`my-1 share-quiz-privacy`}>
                            <FormGroup
                              className={
                                isOwner
                                  ? 'disabled-change-permission mt40 share-quiz-privacy-form-css'
                                  : 'mt40 share-quiz-privacy-form-css'
                              }
                              row>
                              <Col sm={12} md={12} lg={12}>
                                <span
                                  className="enterprise-setting-label"
                                  style={{
                                    fontSize: '14px',
                                  }}>
                                  {allUsersChecked ? 'Remove' : 'Select'} all
                                  users{' '}
                                </span>
                                <CheckBox
                                  checked={allUsersChecked}
                                  onChange={(e) => {
                                    setAllUsersChecked(!allUsersChecked)
                                    onUserSelectAll(!allUsersChecked)
                                  }}
                                />
                              </Col>

                              <Col sm={12} md={12} lg={12}>
                                <div
                                  className="show_shared_trivvy_users"
                                  style={{
                                    overflow: 'hidden',
                                  }}>
                                  <div className="shareTableTrivia">
                                    {!isMobile && (
                                      <LayoutRow className="mobileNoheightActionTable">
                                        <LayoutHeading
                                          className="border justify-content-center bg-white"
                                          colWidth={tableCols.user}
                                          plainTable>
                                          User
                                        </LayoutHeading>

                                        <LayoutHeading
                                          className="border justify-content-center bg-white"
                                          colWidth={tableCols.date}
                                          plainTable>
                                          Added On
                                        </LayoutHeading>

                                        {shareTrivvyViaSMS ? (
                                          <LayoutHeading
                                            className="border justify-content-center bg-white"
                                            colWidth={tableCols.phoneNumber}
                                            plainTable>
                                            Mobile Number
                                          </LayoutHeading>
                                        ) : null}

                                        <LayoutHeading
                                          className="border justify-content-center bg-white"
                                          colWidth={tableCols.sharedVia}
                                          plainTable>
                                          Shared Via
                                        </LayoutHeading>

                                        <LayoutHeading
                                          className="border justify-content-center bg-white"
                                          colWidth={tableCols.action}
                                          plainTable>
                                          Action
                                        </LayoutHeading>
                                      </LayoutRow>
                                    )}

                                    <div
                                      style={{
                                        maxHeight:
                                          sharedWithUsers &&
                                          sharedWithUsers.length > 0
                                            ? '300px'
                                            : '0px',
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        marginLeft: '-15px',
                                      }}
                                      className="hide-scroll w1scr">
                                      {sharedWithUsers &&
                                      sharedWithUsers.length > 0
                                        ? sharedWithUsers.map((item) => {
                                            const phoneNumberExists = usersListAll.find(
                                              (x) => x._id == item.value
                                            )
                                            if (isMobile) {
                                              return (
                                                <LayoutData
                                                  fullWidth
                                                  className="col-pl-0 d-block bg-white">
                                                  <div
                                                    style={{
                                                      alignItems: 'center',
                                                      display: 'flex',
                                                    }}
                                                    className="my-0 pl-2">
                                                    <div className="grp_member_profile_image cursor-pointer">
                                                      {profilePicValidityCheck(
                                                        item.profilePic
                                                      ) ? (
                                                        <div className="list-item__avatar">
                                                          <img
                                                            src={
                                                              item.profilePic
                                                            }
                                                          />
                                                        </div>
                                                      ) : (
                                                        <span
                                                          className="list-item__avatar"
                                                          data-letters={
                                                            item.value ==
                                                            user.profile._id
                                                              ? getInitials(
                                                                  user.profile
                                                                )
                                                              : getInitials(
                                                                  item
                                                                )
                                                          }></span>
                                                      )}
                                                    </div>

                                                    <div className="">
                                                      <div
                                                        className="linkedToolView"
                                                        onClick={() =>
                                                          viewMember(item)
                                                        }>
                                                        {item.value ==
                                                        user.profile._id ? (
                                                          'You'
                                                        ) : (
                                                          <span>
                                                            {' '}
                                                            {
                                                              item.firstName
                                                            } , {item.lastName}
                                                          </span>
                                                        )}
                                                      </div>
                                                    </div>

                                                    <Button
                                                      onClick={() =>
                                                        removeUser(
                                                          item.value,
                                                          item.mobileNumber
                                                        )
                                                      }
                                                      color="danger"
                                                      size="sm"
                                                      className="ml-auto mr-3">
                                                      <BiTrashAlt size={12} />
                                                    </Button>
                                                  </div>
                                                </LayoutData>
                                              )
                                            } else {
                                              return (
                                                <LayoutRow className="ml-0 mr-0">
                                                  <LayoutData
                                                    colWidth={tableCols.user}
                                                    className="bg-white">
                                                    <div
                                                      style={{
                                                        alignItems: 'center',
                                                        display: 'flex',
                                                      }}
                                                      className="my-0 pl-2">
                                                      <div className="grp_member_profile_image cursor-pointer">
                                                        {profilePicValidityCheck(
                                                          item.profilePic
                                                        ) ? (
                                                          <div className="list-item__avatar">
                                                            <img
                                                              src={
                                                                item.profilePic
                                                              }
                                                            />
                                                          </div>
                                                        ) : (
                                                          <span
                                                            className="list-item__avatar"
                                                            data-letters={
                                                              item.value ==
                                                              user.profile._id
                                                                ? getInitials(
                                                                    user.profile
                                                                  )
                                                                : getInitials(
                                                                    item
                                                                  )
                                                            }></span>
                                                        )}
                                                      </div>

                                                      <div className="">
                                                        <div
                                                          className="linkedToolView"
                                                          onClick={() =>
                                                            viewMember(item)
                                                          }>
                                                          {item.value ==
                                                          user.profile._id ? (
                                                            'You'
                                                          ) : (
                                                            <span>
                                                              {' '}
                                                              {
                                                                item.firstName
                                                              } ,{' '}
                                                              {item.lastName}
                                                            </span>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </LayoutData>

                                                  <LayoutData
                                                    colWidth={tableCols.date}
                                                    className="bg-white addedOnDateCss">
                                                    {moment(item.date).format(
                                                      'h:mma on MMM D, YYYY'
                                                    )}
                                                  </LayoutData>
                                                  {shareTrivvyViaSMS ? (
                                                    <LayoutData
                                                      colWidth={
                                                        tableCols.phoneNumber
                                                      }
                                                      className="bg-white">
                                                      {item.mobileNumber &&
                                                      item.mobileNumber.length >
                                                        0
                                                        ? item.mobileNumber
                                                        : 'No'}
                                                    </LayoutData>
                                                  ) : null}

                                                  <LayoutData
                                                    colWidth={
                                                      tableCols.sharedVia
                                                    }
                                                    className="bg-white">
                                                    {item.shareMediums &&
                                                    item.shareMediums.length ? (
                                                      <div className="trivvy-share-via-container">
                                                        {item.shareMediums.includes(
                                                          'EMAIL'
                                                        ) && (
                                                          <div>
                                                            <BiMailSend
                                                              size={'17px'}
                                                              style={{
                                                                marginRight:
                                                                  '3px',
                                                              }}
                                                            />
                                                            <span className="font-13px">
                                                              {item.emailDate
                                                                ? moment(
                                                                    item.emailDate
                                                                  ).format(
                                                                    'MM/DD/YYYY'
                                                                  )
                                                                : moment(
                                                                    item.date
                                                                  ).format(
                                                                    'MM/DD/YYYY'
                                                                  )}
                                                            </span>
                                                          </div>
                                                        )}
                                                        {item.shareMediums.includes(
                                                          'SMS'
                                                        ) && (
                                                          <div>
                                                            <MdOutlineMobileFriendly
                                                              size={'14px'}
                                                            />
                                                            <span className="font-13px">
                                                              {' '}
                                                              {item.smsDate
                                                                ? moment(
                                                                    item.smsDate
                                                                  ).format(
                                                                    'MM/DD/YYYY'
                                                                  )
                                                                : moment(
                                                                    item.date
                                                                  ).format(
                                                                    'MM/DD/YYYY'
                                                                  )}
                                                            </span>
                                                          </div>
                                                        )}
                                                      </div>
                                                    ) : (
                                                      ''
                                                    )}
                                                  </LayoutData>

                                                  <LayoutData
                                                    colWidth={tableCols.action}
                                                    className="bg-white">
                                                    <Button
                                                      onClick={() =>
                                                        removeUser(
                                                          item.value,
                                                          item.mobileNumber
                                                        )
                                                      }
                                                      color="danger"
                                                      size="sm"
                                                      style={{
                                                        width: '40px',
                                                      }}>
                                                      <BiTrashAlt size={12} />
                                                    </Button>
                                                  </LayoutData>
                                                </LayoutRow>
                                              )
                                            }
                                          })
                                        : ''}
                                    </div>

                                    <Row className="mr-0 px-0">
                                      <ActionLayoutData
                                        noDefault
                                        className="col-pl-0 bg-white"
                                        colWidth={12}>
                                        <Select
                                          name="user-select"
                                          placeholder={
                                            'Start typing users name to add new...'
                                          }
                                          //value={newSelectedUser}
                                          isOpen={true}
                                          options={usersList.filter(
                                            (x) =>
                                              !sharedWithUsers.some(
                                                (y) => y.value == x.value
                                              )
                                          )}
                                          onChange={(itm) => onUserSelect(itm)}
                                          className={`trivia-user-share-select-row ${
                                            isMobile ? '' : 'py-2'
                                          }`}
                                          classNamePrefix="select"
                                          open={true}
                                        />
                                      </ActionLayoutData>
                                    </Row>
                                  </div>
                                </div>
                              </Col>
                            </FormGroup>
                          </div>

                          <div className={`mt-4 mb-1 dFelxCenterWithGap`}>
                            <h6>Share Via</h6>
                            <div className="ml-2 d-flex text-left enterprise-setting-label">
                              <div className="pr-2 enterprise-settings-value">
                                <CheckBox
                                  checked={shareTrivvyViaEmail}
                                  onChange={(e) => {
                                    setShareTrivvyViaEmail(e.target.checked)
                                  }}
                                />
                              </div>
                              <div className="text-left enterprise-setting-label">
                                Email
                              </div>
                            </div>
                            <div className="d-flex">
                              <div className="pl-4 pr-2 text-left enterprise-settings-value">
                                <CheckBox
                                  checked={shareTrivvyViaSMS}
                                  onChange={(e) => {
                                    setShareTrivvyViaSMS(e.target.checked)
                                  }}
                                />
                              </div>
                              <div className="text-left enterprise-setting-label">
                                SMS ({smsUsers} of{' '}
                                {triviaShareAndPrivacy &&
                                triviaShareAndPrivacy.sharedWithUsers
                                  ? triviaShareAndPrivacy.sharedWithUsers.length
                                  : 0}{' '}
                                users)
                              </div>
                            </div>
                          </div>

                          <Alert className="my-2">
                            To customize permissions and invite options
                            (Email/SMS text), please go to the individual trivvy
                            page.
                          </Alert>
                        </Collapse>
                      </div> */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : currentStepperStep == 3 ? (
            <div className="createTriviaPopupContainerUi3">
              {/* {
                showLanguageFeature && <div className="my-3">
                <Label>Select Language To Translate</Label>
                  <Select
                    options={TRIVVY_LANGUAGES}
                    onChange={(e) => {
                      if (e) {
                        setTrivvyLanguage(e.value);
                      } else {
                        setTrivvyLanguage("en");
                      }
                    }}
                    value={trivvyLanguage}
                  />
                </div>
              } */}

              {!onlyAllowCustomTextPrompt && (
                <div className="my-3">
                  <Label>Select Difficulty Level</Label>
                  <Select
                    options={DIFFICULTY_LEVELS}
                    onChange={(e) => {
                      if (e) {
                        setDifficultyLevel(e.value)
                      } else {
                        setDifficultyLevel(2)
                      }
                    }}
                    value={difficultyLevel}
                    placeholder="Select Difficulty Level"
                  />
                </div>
              )}

              <div className="my-3">
                <Label>Select End Date</Label>
                <div style={{ maxHeight: '400px' }}>
                  <ReactDatePicker
                    id="actionDueDate"
                    minDate={moment().toDate()}
                    placeholderText="Enter date: MM/DD/YYYY"
                    className="form-control filter-action-date-input"
                    selected={trivvyEndDate}
                    onChange={(v) => {
                      if (v && v != null && v != undefined) {
                        const date = moment(v)
                          .endOf('day')
                          .local()
                        setTrivvyEndDate(date)
                      }
                    }}
                    showYearDropdown
                  />
                </div>
              </div>

              {!onlyAllowCustomTextPrompt && (
                <div className="my-3">
                  <Label>
                    Allow Retakes
                    <OoPopover
                      target="allow_retake"
                      headerText={'Allow Retakes'}
                      bodyText={
                        'Allow users to take/attempt Trivvy multiple times.'
                      }
                    />
                  </Label>
                  <Select
                    options={NUMBER_OF_ATTEMPTS_ALLOWED}
                    onChange={(e) => {
                      if (e && typeof e.value == 'number') {
                        setAllowAttempts(1)
                        setNumberOfAttempts(e.value)
                      } else {
                        if (e && e.value == 'NO') {
                          setAllowAttempts(0)
                          setNumberOfAttempts(null)
                        } else if (e.value == 'MANY') {
                          setAllowAttempts(2)
                          setNumberOfAttempts(null)
                        }
                      }

                      setNumberOfAttempts(e.value)
                    }}
                    value={getValueForAttemptDD()}
                    placeholder="Select No Of Attempts"
                  />
                </div>
              )}

              {!onlyAllowCustomTextPrompt && (
                <div className="my-3">
                  <Label>
                    Allow Randomize Questions{' '}
                    <OoPopover
                      target="allow_randomize"
                      headerText={'Allow Randomize Questions'}
                      bodyText={
                        'Enabling this option will change the questions order everytime users take Trivvy.'
                      }
                    />{' '}
                  </Label>
                  <Toggle
                    className="ml-3"
                    checked={randomizeQuestions}
                    onChange={(e) => {
                      setRandomizeQuestions(e.target.checked)
                    }}
                  />
                </div>
              )}
            </div>
          ) : (
            ''
          )}

          {/* Sharing ui */}

          {/* Other options ui */}
        </div>
      )
    }
  }

  return (
    <div className="trivvyUsersUpload">
      {uiType == 'POPUP' ? (
        <Modal
          isOpen={open}
          className="create-trivia-modal-component trivvyUsersUpload">
          <ModalHeader
            className="trivia_modal_header_bg"
            close={
              <BiX
                className="cursor-pointer"
                color="gray"
                size={30}
                onClick={() => onClose()}
              />
            }>
            Create New Trivvy
          </ModalHeader>
          <ModalBody
            className={`px-4 pt-2 pb-5 ${loading ? 'wrapped-component-on-loading' : ''
              }`}>
            {modalUi()}

            {errorsArr && errorsArr.length ? (
              <Alert color="danger" className="my-2">
                <ul>
                  {errorsArr.map((x) => (
                    <li>{x}</li>
                  ))}
                </ul>
              </Alert>
            ) : (
              ''
            )}
          </ModalBody>

          {!questionPreview.display && (
            <ModalFooter>
              {!loading ? (
                <div>
                  {currentStepperStep == 1 ? (
                    <Button
                      className="trivia-action-button-main"
                      onClick={() => {
                        if (step1Enabled()) {
                          setErrorsArr([])
                          if (onlyAllowCustomTextPrompt) {
                            handleBuiltInAiSurveyStep()
                          } else {
                            setCurrentStepperStep(currentStepperStep + 1)
                          }
                        }
                      }}>
                      Generate
                    </Button>
                  ) : currentStepperStep == 2 ? (
                    <Button
                      className="trivia-action-button-main"
                      onClick={() => {
                        setCurrentStepperStep(currentStepperStep + 1)
                      }}
                      disabled={!step2Enabled()}>
                      Next
                    </Button>
                  ) : (
                    <Button
                      color="success"
                      className="btn-success"
                      onClick={() => {
                        setErrorsArr([])
                        createSurvey()
                      }}>
                      Generate {onlyAllowCustomTextPrompt && 'Survey'}{' '}
                      <FaArrowRight className="ml-2" />
                    </Button>
                  )}
                </div>
              ) : (
                <span>Generating...</span>
              )}
            </ModalFooter>
          )}
        </Modal>
      ) : (
        <div>
          {modalUi()}

          {errorsArr && errorsArr.length ? (
            <Alert color="danger" className="my-2">
              <ul>
                {errorsArr.map((x) => (
                  <li>{x}</li>
                ))}
              </ul>
            </Alert>
          ) : (
            ''
          )}

          {!questionPreview.display && (
            <ModalFooter className="justify-content-between">
              {onBack ? (
                <Button
                  onClick={() => {
                    if (currentStepperStep === 1) {
                      onBack()
                    } else if (currentStepperStep === 2) {
                      setCurrentStepperStep(1)
                    } else if (currentStepperStep === 3) {
                      setCurrentStepperStep(2)
                    }
                  }}
                  style={{
                    height: '35px',
                  }}>
                  Back
                </Button>
              ) : (
                ''
              )}

              {!loading ? (
                <div>
                  {currentStepperStep == 1 ? (
                    <Button
                      className="trivia-action-button-main"
                      onClick={() => {
                        if (step1Enabled()) {
                          setErrorsArr([])
                          if (onlyAllowCustomTextPrompt) {
                            handleBuiltInAiSurveyStep()
                          } else {
                            setCurrentStepperStep(currentStepperStep + 1)
                          }
                        }
                      }}>
                      Generate
                    </Button>
                  ) : currentStepperStep == 2 ? (
                    <Button
                      className="trivia-action-button-main"
                      onClick={() => {
                        setCurrentStepperStep(currentStepperStep + 1)
                      }}
                      disabled={!step2Enabled()}>
                      Next
                    </Button>
                  ) : (
                    <Button
                      color="success"
                      className="btn-success"
                      onClick={() => {
                        setErrorsArr([])
                        if (onlyAllowCustomTextPrompt) {
                          handleBuiltInAiSurveyStep()
                        } else {
                          createSurvey()
                        }
                      }}>
                      Generate {onlyAllowCustomTextPrompt && 'Survey'}{' '}
                      <FaArrowRight className="ml-2" />
                    </Button>
                  )}
                </div>
              ) : (
                <span>Generating...</span>
              )}
            </ModalFooter>
          )}
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setCreateTrivvyLoader: (data) =>
      dispatch(actionCreators.setCreateTrivvyLoader(data)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(CreateTriviaPopup, axios))
